import { render, staticRenderFns } from "./p-packages-active-list.vue?vue&type=template&id=f8d4bd4e&scoped=true"
import script from "./p-packages-active-list.vue?vue&type=script&lang=js"
export * from "./p-packages-active-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d4bd4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8d4bd4e')) {
      api.createRecord('f8d4bd4e', component.options)
    } else {
      api.reload('f8d4bd4e', component.options)
    }
    module.hot.accept("./p-packages-active-list.vue?vue&type=template&id=f8d4bd4e&scoped=true", function () {
      api.rerender('f8d4bd4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mpackages/views/p-packages-active-list.vue"
export default component.exports